import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

export interface FilterOption {
  value: string;
  label: string;
}

interface FilterSelectProps {
  label: string;
  value: FilterOption | null;
  onChange: (value: FilterOption | null) => void;
  options: FilterOption[];
  placeholder?: string;
  loading?: boolean;
  disabled?: boolean;
}

/**
 * The standard single-pick FilterBar dropdown — a type-to-narrow combobox.
 * Stands in for the mix of plain MUI Select, MUI Autocomplete and
 * react-select that different pages had grown independently, each sized
 * and styled slightly differently.
 */
const FilterSelect: React.FC<FilterSelectProps> = ({
  label,
  value,
  onChange,
  options,
  placeholder,
  loading,
  disabled,
}) => (
  <Autocomplete
    size="small"
    options={options}
    value={value}
    onChange={(_, opt) => onChange(opt)}
    getOptionLabel={opt => opt.label}
    isOptionEqualToValue={(opt, val) => opt.value === val.value}
    loading={loading}
    disabled={disabled}
    renderInput={params => (
      // shrink: without it, the unfocused label sits over the placeholder's slot.
      <TextField
        {...params}
        label={label}
        placeholder={placeholder ?? `All ${label}`}
        slotProps={{ inputLabel: { shrink: true } }}
      />
    )}
  />
);

export default FilterSelect;
